import i18n from "../../../../Utils/i18next/i18next";
import store from "../../../../store";
import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { cloneDeep, set } from "lodash";
import moment from "moment";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { tenderReducer } = store.getState();
  const { updateTableRegistry, loadData, update, updateSingleRegistry, uuid } =
    props;
  const data = cloneDeep(values);

  if (values?.deadlineDate) {
    let deadline = moment(values?.deadlineDate);
    if (values?.deadlineTime) {
      const deadLineTime = moment(values?.deadlineTime);
      let hours = deadLineTime.hours();
      let minutes = deadLineTime.minutes();
      let seconds = deadLineTime.seconds();
      deadline = deadline.clone().add(hours, 'hours').add(minutes, 'minutes').add(seconds, 'seconds');

    }
    set(data, "deadline", deadline);
  }

  if (values?.representative?.value)
    set(data, "representative.uuid", values?.representative?.value);
 
  let payload;

  if (!update) {
    data.status = tenderReducer?.availableStatuses.find((el) => !!el.isSelected);

    const res = await GlobalAuthFetch({
      path: `/tender`,
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/tender/${uuid}`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);
    props.setErrorHeader(1, true);

    return;
  }

  props.setErrorHeader(0, false);
  props.setErrorHeader(1, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();
  props.handleHide();
};

export const onValidate = (values, props) => {
  // const { update } = props;
  const errorsStep0 = {};
  const errorsStep1 = {};

  if (!values.deadlineDate) {
    errorsStep0.deadlineDate = t("global:tender.errors.deadlineDate");
  }

  if (!values.contractor) {
    errorsStep0.contractor = t("global:tender.errors.contractor");
  }

  if (!values.caseNumber) {
    errorsStep0.caseNumber = t("global:tender.errors.caseNumber");
  }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }
  if (
    !props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length > 0
  ) {
    props.setErrorHeader(1, true);
  }
  if (
    !!props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length <= 0
  ) {
    props.setErrorHeader(1, false);
  }
  return { ...errorsStep0, ...errorsStep1 };
};
